import { Component, OnDestroy, OnInit } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { OnboardingProductsStore } from '../../../store/store';
import {
  LaborManagerCreateActions,
  IsCTSEmployeeActions,
  UiActions
} from '../../../store/actions';
import { DataNotClientService } from '../../../services/data-not-client.service';
import { SessionService } from '../../../services/session.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ApiResponseStatus, StepsClientTypes, StepsNotClientTypes, activitiesCodes } from '../../../shared/enums';
import { jobTitles } from '../data/jobTitles';
import { DatePipe } from '@angular/common';
import { AccountFormatService } from '../../../services/account-format.service';
import { DataClientService } from '../../../services/data-client.service';
import { LabourData, RequestLaborManagerCreate } from '../../../shared/interfaces';
import { environment } from '../../../../environments/environment';
import { TagPage } from '../../../store/actions/ui.actions';
import { LoadingService } from '../../../services/loading.service';
import { Subscription } from 'rxjs';
import { LabourHandler } from './handler/labour.handler';

@Component({
  selector: 'lib-labour-information',
  templateUrl: './labour-information.component.html',
  styleUrls: ['../../../global.scss', './labour-information.component.scss']
})

export class LabourInformationComponent implements OnInit, OnDestroy {
  private isWC = environment.isWc;
  accountType: string;
  isCTS = false;
  jobTitles: any = jobTitles;
  formData: FormGroup;
  ctsNewActivities: any;
  ctsDefaultValue: any = {
    codigo: null,
    nombre: ''
  };
  today: string;
  dateInvalid: boolean;
  privateMode = false;
  dataService: DataNotClientService | DataClientService;

  // Controles para mostrar o no un input
  showRuc: boolean;
  showDate: boolean;
  showProfession: boolean;
  showCompanyName: boolean;
  showSalaryCheck: boolean;

  // Controles para mostrar "Opcional"
  showOptionalRucLabel: boolean;
  showOptionalCompanyNameLabel: boolean;
  showOptionalProfessionLabel: boolean;
  showOptionalDateLabel: boolean;

  subs = new Subscription();
  activities: any;
  activities$: LabourData[];

  laborManagerCreate$ = this.store.pipe(
    select(OnboardingProductsStore.selectors.laborManagerCreate)
  );

  isCTSEmployeeSuscription$ = this.store.pipe(
    select(OnboardingProductsStore.selectors.isCTSEmployee)
  );

  constructor(
    public sessionService: SessionService,
    private store: Store<OnboardingProductsStore.AppState>,
    private dataNotClientService: DataNotClientService,
    private dataClientService: DataClientService,
    private _fb: FormBuilder,
    private datePipe: DatePipe,
    private accountFormatService: AccountFormatService,
    private loadingService: LoadingService,
    private labourHandler: LabourHandler
  ) {
    this.accountType = this.accountFormatService.getName();
    this.setFormOptional();
  }

  laborManagerCreateSuscription = this.laborManagerCreate$.subscribe(({ response, error }) => {
    // error case
    if (error !== null) {
      this.store.dispatch(LaborManagerCreateActions.cleanState());
      if (this.privateMode) {
        this.store.dispatch(UiActions.Navigate({ step: StepsClientTypes.STEP_SERVICE_ERROR }));
      } else {
        this.store.dispatch(UiActions.Navigate({ step: StepsNotClientTypes.STEP_SERVICE_ERROR }));
      }
    }
    if (response) {
      if (response.client.operationState.code === ApiResponseStatus.OK) {
        this.store.dispatch(LaborManagerCreateActions.cleanState());
        if (this.privateMode) {
          this.store.dispatch(UiActions.Navigate({ step: StepsClientTypes.STEP_INFORMATION_PEP }));
        } else {
          if (this.dataService.isIsJointAccount()) {
            this.store.dispatch(UiActions.Navigate({ step: StepsNotClientTypes.STEP_JOINT_INFORMATION_1 }));
          } else {
            this.store.dispatch(UiActions.Navigate({ step: StepsNotClientTypes.STEP_NATIONALITY }));
          }
        }
      }
    }
  });

  isCTSEmployeeSuscription = this.isCTSEmployeeSuscription$.subscribe(({ response, error }) => {
    // error case
    if (error !== null) {
      this.store.dispatch(IsCTSEmployeeActions.cleanState());
    }
    // Empleado no existe caso
    if (response) {
      if (response.client.operationState.code === ApiResponseStatus.OK && response.client.data.employee) {
        this.isCTS = true;
        this.dataService.setIsCTS(this.isCTS);
        this.formData.get('workActivityType').setValue(activitiesCodes.DEPENDIENTE);
        this.formData.controls['workActivityType'].disable();
        setTimeout(() => {
          this.formData.get('companyName').setValue(response.client.data.employee.enterprise.name);
          this.formData.get('dateEntryWork').setValue(this.datePipe.transform(response.client.data.employee.dateOfAdmission, 'yyyy-MM-dd'));
          this.formData.get('rucCompany').setValue(response.client.data.employee.enterprise.document.documentNumber);
          this.formData.get('companyName').disable();
          this.formData.controls['dateEntryWork'].disable();
          this.formData.controls['rucCompany'].disable();
          this.formData.setErrors({ invalid: true });
        }, 100);
        this.loadingService.loading = false;
        this.activityChange();
        this.store.dispatch(IsCTSEmployeeActions.cleanState());
      }
    }
  });

  ngOnInit() {
    // Se consumen actividades laborales desde STATIC
    this.subs.add(this.labourHandler.getActivities().subscribe((data) => {
      this.activities$ = data.newActivities;
      if (this.accountType === 'CTS') {
        this.ctsDefaultValue = this.activities$.find((activity) => activity.nombre === 'Dependiente');
        this.ctsNewActivities = this.activities$.filter((activity) => activity.nombre !== 'Dependiente');
        this.setFormRequired(this.ctsDefaultValue.codigo);
      } else {
        this.setFormOptional();
      }
      this.activities = this.accountType === 'CTS' ? this.ctsNewActivities : this.activities$;
    }));
    this.setService();
    this.today = this.datePipe.transform(new Date(), 'yyyy-MM-dd');
    // TODO -> Obviar llamado si es mancomunado y llamar en joint con datos en conjunto
    // this.store.dispatch(IsCTSEmployeeActions.getIsCTSEmployee());
    if (this.accountType === 'CTS') {
      this.showRuc = true;
      this.showDate = true;
      this.showCompanyName = true;
      this.showProfession = true;
    }
    setTimeout(() => {
      this.loadingService.loading = false;
    }, 100);
  }

  ngOnDestroy() {
    this.isCTSEmployeeSuscription.unsubscribe();
    this.laborManagerCreateSuscription.unsubscribe();
  }

  setService() {
    this.privateMode = (environment.mode === 'IN' || environment.mode === 'PF') ? true : false;
    this.dataService = this.privateMode ? this.dataClientService : this.dataNotClientService;
    const googleAnalytics = { is_joint_account: this.dataService.isIsJointAccount() };
    this.store.dispatch(TagPage({ text: 'job-information', extras: googleAnalytics }));
  }

  continue() {
    this.loadingService.loading = true;
    console.log(this.dataService.isIsJointAccount());
    if (this.dataService.isIsJointAccount()) {
      const step = this.privateMode ? StepsClientTypes.STEP_JOINT_INFORMATION_LABOR_CLIENT : StepsNotClientTypes.STEP_JOINT_INFORMATION_1;
      this.setServiceData();
      return this.store.dispatch(UiActions.Navigate({ step }));
    } else {
      this.callLaborManager();
    }
  }

  activityChange() {
    const activityValue = this.formData.controls['workActivityType'].value;
    if (activityValue === 'null') {
      this.resetForm();
    } else if (this.accountType === 'CTS') {
      this.setFormRequired(activityValue);
    } else if (activityValue === activitiesCodes.DESEMPLEADO || activityValue === activitiesCodes.AMA_DE_CASA
      || activityValue === activitiesCodes.ESTUDIANTE || activityValue === activitiesCodes.JUBILADO) {
      this.setFormOptional(activityValue);
      this.showCompanyName = false;
      this.showRuc = false;
      this.showDate = false;
      this.showProfession = false;
      this.showSalaryCheck = false;
    } else if (activityValue === activitiesCodes.INDEPENDIENTE) {
      this.showCompanyName = true;
      this.showDate = true;
      this.showRuc = false;
      this.showProfession = false;
      this.showSalaryCheck = false;
      this.showOptionalCompanyNameLabel = false;
      this.formData = this._fb.group({
        workActivityType: [activityValue, Validators.required],
        dateEntryWork: [''],
        companyName: ['', Validators.required]
      });
    } else if (activityValue === activitiesCodes.FFAA) {
      this.formData = this._fb.group({
        workActivityType: [activityValue, Validators.required],
        dateEntryWork: [''],
        companyName: ['', Validators.required],
        rucCompany: ['', [Validators.minLength(11), Validators.maxLength(11)]],
        profession: [null]
      });
      this.showCompanyName = true;
      this.showRuc = true;
      this.showDate = true;
      this.showProfession = true;
      this.showOptionalCompanyNameLabel = false;
      this.showOptionalDateLabel = true;
      this.showOptionalProfessionLabel = true;
      this.showOptionalRucLabel = true;
      this.showSalaryCheck = false;
    } else if (activityValue === activitiesCodes.INFORMAL) {
      this.showCompanyName = true;
      this.showRuc = false;
      this.showDate = false;
      this.showProfession = false;
      this.showSalaryCheck = false;
      this.showOptionalCompanyNameLabel = false;
      this.formData = this._fb.group({
        workActivityType: [activityValue, Validators.required],
        companyName: ['', Validators.required]
      });
    } else if (activityValue === activitiesCodes.DEPENDIENTE) {
      if (this.accountType === 'Ahorro') {
        this.formData = this._fb.group({
          workActivityType: [activityValue, Validators.required],
          dateEntryWork: [''],
          companyName: ['', [Validators.required]],
          rucCompany: ['', [Validators.minLength(11), Validators.maxLength(11)]],
          profession: [null]
        });
        this.showOptionalCompanyNameLabel = false;
        this.showOptionalRucLabel = true;
        this.showOptionalDateLabel = true;
        this.showOptionalProfessionLabel = true;
      } else if (this.accountType === 'Flex') {
        // Deposito de sueldo
        this.showSalaryCheck = true;
        this.formData = this._fb.group({
          workActivityType: [activityValue, Validators.required],
          dateEntryWork: [''],
          companyName: ['', [Validators.required]],
          rucCompany: ['', [Validators.minLength(11), Validators.maxLength(11)]],
          profession: [null],
          salaryCheck: [false]
        });
        this.showOptionalCompanyNameLabel = false;
        this.showOptionalRucLabel = true;
        this.showOptionalDateLabel = true;
        this.showOptionalProfessionLabel = true;
      }
      this.showRuc = true;
      this.showDate = true;
      this.showCompanyName = true;
      this.showProfession = true;
    }
  }

  checkYears(e) {
    if (Date.parse(this.formData.controls['dateEntryWork'].value) > Date.parse(this.today)) {
      this.dateInvalid = true;
    } else {
      this.dateInvalid = false;
    }
  }

  callLaborManager() {
    this.setServiceData();
    const request: RequestLaborManagerCreate = {
      client: {
        workActivityType: this.dataService.getWorkActivityType()
      }
    };
    if (this.dataService.getDateEntryWork()) {
      request.client.dateEntryWork = this.dataService.getDateEntryWork();
    }
    if (this.dataService.getCompanyName()) {
      request.client.companyName = this.dataService.getCompanyName();
    }
    if (this.dataService.getRucCompany()) {
      request.client.rucCompany = this.dataService.getRucCompany();
    }
    if (this.dataService.getProfession()) {
      request.client.profession = this.dataService.getProfession();
    }
    this.store.dispatch(LaborManagerCreateActions.getLaborManagerCreate({ request }));
  }

  setSalaryCheck() {
    const activityValue = this.formData.controls['workActivityType'].value;
    const salaryCheckState = !this.formData.controls.salaryCheck.value;
    if (activityValue === activitiesCodes.DEPENDIENTE) {
      // Deposito de sueldo
      if (salaryCheckState) {
        this.formData = this._fb.group({
          workActivityType: [activityValue, Validators.required],
          rucCompany: ['', Validators.required],
          companyName: ['', Validators.required],
          dateEntryWork: [''],
          profession: [null],
          salaryCheck: [salaryCheckState]
        });
      } else {
        this.formData = this._fb.group({
          workActivityType: [activityValue, Validators.required],
          companyName: ['', Validators.required],
          salaryCheck: [salaryCheckState],
          profession: [null],
          dateEntryWork: [''],
          rucCompany: ['']
        });
      }
      this.showOptionalCompanyNameLabel = false;
      this.showOptionalDateLabel = true;
      this.showOptionalProfessionLabel = true;
      this.showSalaryCheck = true;
      this.showRuc = true;
      this.showDate = true;
      this.showCompanyName = true;
      this.showProfession = true;
      this.showOptionalRucLabel = !salaryCheckState;
    }
  }

  setServiceData() {
    if (this.formData.controls['workActivityType'] && this.formData.controls['workActivityType'].value) {
      this.dataService.setWorkActivityType(this.formData.controls['workActivityType'].value);
    }
    if (this.formData.controls['dateEntryWork'] && this.formData.controls['dateEntryWork'].value) {
      this.dataService.setDateEntryWork(this.formData.controls['dateEntryWork'].value);
    }
    if (this.formData.controls['companyName'] && this.formData.controls['companyName'].value) {
      this.dataService.setCompanyName(this.formData.controls['companyName'].value);
    }
    if (this.formData.controls['rucCompany'] && this.formData.controls['rucCompany'].value) {
      this.dataService.setRucCompany(this.formData.controls['rucCompany'].value);
    }
    if (this.formData.controls['profession'] && this.formData.controls['profession'].value) {
      this.dataService.setProfession(this.formData.controls['profession'].value);
    }
  }

  setFormOptional(workActivity = null) {
    this.formData = this._fb.group({
      workActivityType: [workActivity, Validators.required],
      dateEntryWork: [''],
      companyName: [''],
      rucCompany: ['', [Validators.minLength(11), Validators.maxLength(11)]],
      profession: [null],
      salaryCheck: [false]
    });
    this.showOptionalCompanyNameLabel = true;
    this.showOptionalRucLabel = true;
    this.showOptionalProfessionLabel = true;
    this.showOptionalDateLabel = true;
  }

  setFormRequired(workActivity) {
    this.formData = this._fb.group({
      workActivityType: [workActivity, Validators.required],
      dateEntryWork: ['', Validators.required],
      companyName: ['', Validators.required],
      rucCompany: ['', [Validators.required, Validators.minLength(11), Validators.maxLength(11)]],
      profession: [null, Validators.required],
      salaryCheck: [false]
    });
    this.showOptionalCompanyNameLabel = false;
    this.showOptionalRucLabel = false;
    this.showOptionalProfessionLabel = false;
    this.showOptionalDateLabel = false;
  }

  resetForm() {
    this.formData.controls['workActivityType'].patchValue(null);
    this.showCompanyName = false;
    this.showRuc = false;
    this.showDate = false;
    this.showProfession = false;
    this.showSalaryCheck = false;
  }

  getIsWC(): boolean {
    const isWc = !!this.isWC;
    return isWc;
  }
}
